export const REQUEST_TIMEOUT = 60_000; // 60 seconds default timeout
export const MAX_INFLIGHT_REQUESTS = 100; // Prevent unbounded map growth
